import { render, staticRenderFns } from "./StructuralMemberTable.vue?vue&type=template&id=2e594e33"
import script from "./StructuralMemberTable.vue?vue&type=script&lang=ts"
export * from "./StructuralMemberTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e594e33')) {
      api.createRecord('2e594e33', component.options)
    } else {
      api.reload('2e594e33', component.options)
    }
    module.hot.accept("./StructuralMemberTable.vue?vue&type=template&id=2e594e33", function () {
      api.rerender('2e594e33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Info/StructuralMemberTable.vue"
export default component.exports